import { Component, OnInit } from '@angular/core';
import {commonService} from "../../service/common.service";
import { scheduleService } from '../../service/schedule.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http'

@Component({
  selector: 'app-viewstreammpg',
  templateUrl: './viewstreammpg.component.html',
  styleUrls: ['./viewstreammpg.component.css'],
  providers:[commonService,scheduleService]
})
export class ViewstreammpgComponent implements OnInit {
  isError=false;
  msg:any;
  mappinglist:any;
  isSuccess=false;
  totalrow:number;
  searchtxt:string;
  notfound=false;
  pageSize = 10;
  currentPage = 0;
  start=0;
  end=10; 
  pageEvent: any;
  streammpglist:any;
  constructor(public router: Router,private _schedule:scheduleService,private commonService:commonService,private route: ActivatedRoute) { 
    this.route.queryParams.subscribe(params => {
      this.searchtxt=params['search'];
    });
  }


  ngOnInit() {
    this.localstoragemmsg();
    this.getstreamlist();
  }

  // paging handle
  handlePage(e: any){
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.end = this.pageSize;
    this.start = this.currentPage * this.pageSize;
    this.getstreamlist()    
  }
  
  getstreamlist(){
    this._schedule.streamlist(this.start,this.end,this.searchtxt).subscribe((data : any)=>{
            if(data.error==0){ 
              this.streammpglist = data.results.rows;
              console.log(this.streammpglist);   
              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
}

filterform(searchtxt){
  var txt = searchtxt.value.search.trim();
  if(txt!=""){
  this.router.navigateByUrl('/admin/discussion/viewstreammpg?search='+txt);
  }else{
    this.router.navigateByUrl('/admin/course/vcourse');
  }
  this.searchtxt=txt;
  this.start=0;
  this.getstreamlist();  
}
editstreamm(Id){
 this.router.navigateByUrl('/admin/discussion/editstreammpg?cid='+btoa(Id));
}
delstreamm(Id){

  
    if(window.confirm('Are sure you want to delete this Stream mapping ?')){
      this._schedule.delstremm(Id).subscribe((data : any)=>{
        if(data.error==0){
          this.isSuccess=true;
          this.msg="Stream mapping has been deleted successfully!";
          this.getstreamlist()
        }else{
          this.isError = true;
          this.msg=data.error;
        }
    },
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    });
     }  
    

}


  localstoragemmsg(){
    if(localStorage.getItem('isSuccess')=="Yes"){
      this.isSuccess=true;
      this.msg =    localStorage.getItem('msg');
      localStorage.removeItem('isSuccess');
      localStorage.removeItem('msg');
    }
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/viewstreammpg/viewstreammpg.component.ts